import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { slideInFromRightWeighted } from '../../shared/component/Animation';
import { paperTextureSmall } from '../../shared/component/paperTexture';
import { useExportStationWorkStore } from '../../shared/store/exportStationWorkStore';
import { useModalWorkTagStore } from '../../shared/store/workTagStore';
import WorkListPdfModalSelectAndIndexing from './WorkListPdfModalSelectAndIndexing';
import WorkListPdfModalCreate from './WorkListPdfModalCreate';

type WorkListPdfModalPhase = 'select&indexing' | 'create';

export interface WorkListPdfModalProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

/**
 * CREATE_WORK_PDF 모달 기본 틀.
 * 상세 옵션/생성 로직은 추후 연결한다.
 */
const WorkListPdfModal: React.FC<WorkListPdfModalProps> = ({ setIsUserInput }) => {
  const { isClosing, clearModal } = useModalStore();
  const { selectedDataList, clearSelectedDataList, clearSimpleList } = useExportStationWorkStore();
  const { clearSelectedModalTags } = useModalWorkTagStore();
  const [phase, setPhase] = useState<WorkListPdfModalPhase>('select&indexing');

  const clearExportModalState = useCallback(() => {
    clearSelectedDataList();
    clearSimpleList();
    clearSelectedModalTags();
  }, [
    clearSelectedDataList,
    clearSimpleList,
    clearSelectedModalTags,
  ]);

  const handleCloseModal = () => {
    clearExportModalState();
    clearModal(700);
  };

  useEffect(() => () => {
    clearExportModalState();
    setIsUserInput(false);
  }, [clearExportModalState, setIsUserInput]);

  useEffect(() => {
    setIsUserInput(selectedDataList.length > 0);
  }, [selectedDataList.length, setIsUserInput]);

  const handleIndexingNext = () => {
    setPhase('create');
  };

  return (
    <LeftModalFrame
      onClick={(e) => e.stopPropagation()}
      $isSelectAndIndexingPhase={phase === 'select&indexing'}
      $isClosing={isClosing}
    >
      <SelectWorkComp>
        {phase === 'select&indexing' ? (
          <WorkListPdfModalSelectAndIndexing
            onNextStep={handleIndexingNext}
            onCloseModal={handleCloseModal}
          />
        ) : (
          <WorkListPdfModalCreate
            onBack={() => setPhase('select&indexing')}
            onCloseModal={handleCloseModal}
          />
        )}
      </SelectWorkComp>
    </LeftModalFrame>
  );
};

const LeftModalFrame = styled.div<{ $isClosing: boolean, $isSelectAndIndexingPhase: boolean }>`
  position: absolute;
  right: clamp(20px, 2vw, 30px);
  bottom: clamp(25px, 3vw, 50px);
  width: ${({ $isSelectAndIndexingPhase }) => $isSelectAndIndexingPhase ? 'clamp(600px, 70vw, 800px)' : 'clamp(440px, 45vw, 600px)'};
  height: 88vh;
  max-height: 88vh;
  min-height: 0;
  padding: 20px;
  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) => ($isClosing ? 'translateX(100%)' : 'translateX(0)')};
  transition: all 0.6s ease-out;
  ${paperTextureSmall}
  ${slideInFromRightWeighted}
`;

const SelectWorkComp = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  min-height: 0;
`;

export default WorkListPdfModal;
